/***
 * Created on 2023/7/10
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useMemo, useState} from 'react';
import {QueryClientProvider, QueryClient, useInfiniteQuery, useQueryClient} from "@tanstack/react-query";
import {apiGet} from "../../service/api";
import {formatDate} from "../../service/datetime";
import ActivityGroup from "./activity_group";
import { useInView } from 'react-intersection-observer';
import sharedI18n from "common/SharedI18n";
import {useTranslation, I18nextProvider} from "react-i18next";
import {useLanguage} from 'common/Hook';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});

function Activity(props) {
    const { ref, inView } = useInView();
    const [rangeType, setRangeType] = useState('all');
    const queryClient = useQueryClient();
    const { t, i18n } = useTranslation();
    useLanguage(i18n);

    const {data, fetchNextPage, hasNextPage} = useInfiniteQuery({
        queryKey: ['activities', rangeType],
        queryFn: async ({pageParam=0}) => {
            return await apiGet(`/ajax/activity?offset=${pageParam}&limit=10&rangeType=${rangeType}`)
        },
        getNextPageParam: (lastPage, pages) => {
            if (!lastPage || lastPage.length <= 0) return undefined;
            return pages.length * 10;
        }
    });

    const createDateGroup = () => {
        let group = {};
        if (!data?.pages) return {};

        for (const page of data?.pages) {
            for (const act of page) {
                const key = formatDate(t, act.created_at);
                if (group?.[key]) {
                    group[key].push(act);
                } else {
                    group[key] = [act]
                }
            }
        }
        return group;
    }

    const getGroupDate = useMemo(() => {
        return createDateGroup()
    }, [rangeType, data?.pageParams]);

    const selectRangeType = (range) => {
        setRangeType(range);
    }

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);


    return (
        <section className="page-wrapper">
            <header className="page-header">{t('@Activities@')}</header>
            <div className="page-toolbar !pt-0">
                <div className="comp-toolbar">
                    <div className="toolbar">
                        <div className="toolbar__col-left">
                            <div className="comp-segmented-control">
                                <div className="segmented-control">
                                    <ul>
                                        <li className={`segmented-control__segment text-ellipsis flex-1 cursor-pointer ${rangeType === 'today' ? 'active': ''}`} onClick={()=>selectRangeType('today')}>{t('@Today@')}</li>
                                        <li className={`segmented-control__segment text-ellipsis flex-1 cursor-pointer ${rangeType === 'week' ? 'active': ''}`} onClick={()=>selectRangeType('week')}>{t('@Current Week@')}</li>
                                        <li className={`segmented-control__segment text-ellipsis flex-1 cursor-pointer ${rangeType === 'month' ? 'active': ''}`} onClick={()=>selectRangeType('month')}>{t('@Current Month@')}</li>
                                        <li className={`segmented-control__segment text-ellipsis flex-1 cursor-pointer ${rangeType === 'all' ? 'active': ''}`} onClick={()=>selectRangeType('all')}>{t('@All@')}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="page-body">
                <div className="page-content page-content--activities">
                    <div className="activities-wrapper">
                        {
                            // data?.pages && Object.keys(getGroupDate).map(key=> <ActivityGroup group={key} data={getGroupDate[key]} key={key}/>)
                            // console.log(data)
                            data?.pages && Object.keys(getGroupDate).map(key=><ActivityGroup group={key} data={getGroupDate[key]} key={key}/>)
                        }

                        <div ref={ref} />
                    </div>
                </div>
            </section>
        </section>
    );
}

function ActivityIndex(props) {
    return (
        <I18nextProvider i18n={sharedI18n} >
            <QueryClientProvider client={queryClient}>
                <Activity />
            </QueryClientProvider>
        </I18nextProvider>
    );
}

export default ActivityIndex;